import {ID} from '~/lib/model';

export const clientsLinks = {
    clients: () => '/clients',
    agencies: () => '/clients/agencies',
    agency: (agencyId: ID) => `/clients/agencies/${agencyId}`,
    sellers: () => '/clients/sellers',
    seller: (sellerId: ID) => `/clients/sellers/${sellerId}`,
    users: (userId: ID) => `/users/${userId}`,
    sellersJson: () => '/sellers-json',
    selfServeSeller: () => '/settings'
};
